
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-user-picker-config",
})
export default class UserPickerConfig extends ComponentConfigMixins {}
